import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayersTwo: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layers-two, stack"><path d="M8 12.1672L2.75 15.0938L12 20.25L21.25 15.0938L16 12.1672M12 3.75L2.75 8.90625L8.3 12L12 14.0625L15.7 12L21.25 8.90625L12 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLayersTwo;
